import { render, staticRenderFns } from "./ShiftReport.vue?vue&type=template&id=20d55cee&scoped=true"
import script from "./ShiftReport.vue?vue&type=script&lang=js"
export * from "./ShiftReport.vue?vue&type=script&lang=js"
import style0 from "./ShiftReport.vue?vue&type=style&index=0&id=20d55cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d55cee",
  null
  
)

export default component.exports